import { useEffect } from "react";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import { setupAuthInterceptor, setupSignOutInterceptor } from "../api/client";

export const useApiAuth = () => {
  const token = useAuthHeader();
  const signOut = useSignOut();

  useEffect(() => {
    setupSignOutInterceptor(signOut);
  }, [signOut]);

  useEffect(() => {
    setupAuthInterceptor(() => {
      if (!token) return null;
      return token;
    });
  }, [token]);

  return null;
};
